
import { useCallback, useMemo } from 'react'

// Hook pour optimiser les performances avec memoization intelligente
export const usePerformanceOptimization = () => {
  
  // Debounce pour les requêtes
  const debounce = useCallback((func: Function, delay: number) => {
    let timeoutId: NodeJS.Timeout
    return (...args: any[]) => {
      clearTimeout(timeoutId)
      timeoutId = setTimeout(() => func(...args), delay)
    }
  }, [])

  // Throttle pour les événements de scroll
  const throttle = useCallback((func: Function, limit: number) => {
    let inThrottle: boolean
    return (...args: any[]) => {
      if (!inThrottle) {
        func(...args)
        inThrottle = true
        setTimeout(() => inThrottle = false, limit)
      }
    }
  }, [])

  // Préchargement intelligent des routes
  const preloadRoute = useCallback((routePath: string) => {
    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = routePath
    document.head.appendChild(link)
  }, [])

  return { debounce, throttle, preloadRoute }
}
